export const environment = {
    production: false,
  };


  export const PORT = '';
  export const PREFIX = 'https://';
  export const API_URL = PREFIX + 'sit.forty2.cloud' + PORT + '/api/';

